module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ElContainer', {
    attrs: {
      "id": "app",
      "direction": "vertical"
    }
  }, [_c('ElHeader', {
    staticClass: "header",
    attrs: {
      "height": "51.2px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars fa-lg menu",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.showHideMenu()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.mrc-asia.com/home"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("./assets/mrclogo.svg"),
      "alt": "MRC Asia"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item header-item"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('ul', {
    staticStyle: {
      "margin": "auto"
    }
  }, [_c('li', {
    staticClass: "nav-item-comp"
  }, [_c('ElButton', {
    staticClass: "btncomp",
    attrs: {
      "type": "primary",
      "plain": "",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.showHideMoreServices()
      }
    }
  }, [_c('ElButton', {
    attrs: {
      "type": "danger",
      "icon": "el-icon-menu",
      "circle": ""
    }
  }), _vm._v("\n                More Services "), _c('i', {
    staticClass: "el-icon-caret-bottom"
  })], 1)], 1)])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item header-item"
  }, [_c('Dropdown', {
    staticClass: "dropdown",
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', [_vm._v("\n            " + _vm._s(_vm.currentUser.username) + "\n            "), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(_vm.isNewsTagger) ? _c('DropdownItem', {
    attrs: {
      "command": "newtagger"
    }
  }, [_vm._v("News Tagger")]) : _vm._e(), _vm._v(" "), (_vm.isMdsUser) ? _c('DropdownItem', {
    attrs: {
      "command": "dataentry"
    }
  }, [_vm._v("Edit Company Details")]) : _vm._e(), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "command": "cp"
    }
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "command": "logout"
    }
  }, [_vm._v("Log out")])], 1)], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item header-item hidden-md-and-down"
  }, [_c('a', [_c('p')])]), _vm._v(" "), (_vm.isMdsUser) ? _c('li', {
    staticClass: "nav-item header-item hidden-xs-only"
  }, [_c('i', {
    staticClass: "fa fa-lg",
    class: _vm.classObject,
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.setChatActive(!_vm.chatActive)
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('ElContainer', [_c('transition', {
    attrs: {
      "name": "el-fade-in"
    }
  }, [_c('ElAside', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMoreServices),
      expression: "showMoreServices"
    }],
    staticClass: "left-menu",
    staticStyle: {
      "background-color": "rgba(24,32,40,0.9)",
      "padding": "20px 0 0 10px"
    },
    attrs: {
      "width": "450px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "5px 20px"
    }
  }, [_c('i', {
    staticClass: "el-icon-d-arrow-left close-left-menu pull-right",
    on: {
      "click": _vm.showHideMoreServices
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, _vm._l((_vm.moreservices), function(mitem, i) {
    return _c('div', {
      key: ("3" + i),
      staticClass: "nav-menu-icon"
    }, [_c('ElButton', {
      staticStyle: {
        "width": "100%",
        "height": "100%",
        "align-items": "center",
        "display": "flex",
        "flex-direction": "row"
      },
      attrs: {
        "type": mitem.color,
        "disabled": mitem.disabled
      },
      on: {
        "click": function($event) {
          return _vm.handleCommand(mitem.command)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons",
      staticStyle: {
        "font-size": "1.5em",
        "width": "24px",
        "height": "24px"
      }
    }, [_vm._v("\n                " + _vm._s(mitem.icon) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "txt",
      class: {
        mute: mitem.disabled
      },
      domProps: {
        "innerHTML": _vm._s(mitem.module)
      }
    })])], 1)
  }), 0)])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-fade-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chatActive),
      expression: "chatActive"
    }],
    staticClass: "chat-popup",
    style: ({
      height: (_vm.windowHeight - 52) * 5 / 6 + 'px'
    })
  }, [_c('Chatbox', {
    ref: "chatbox",
    attrs: {
      "msges": _vm.msges
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-fade-in"
    }
  }, [_c('ElAside', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    staticClass: "left-menu",
    staticStyle: {
      "background-color": "rgba(24,32,40,0.9)"
    },
    attrs: {
      "width": "280px"
    }
  }, [_c('ElMenu', {
    attrs: {
      "router": "",
      "unique-opened": "",
      "default-openeds": _vm.openedMenu,
      "default-active": _vm.$route.path,
      "background-color": "rgba(24,32,40,0.5)",
      "text-color": "#fff",
      "active-text-color": "#ffd04b"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 20px 5px"
    }
  }, [_c('i', {
    staticClass: "el-icon-d-arrow-left close-left-menu pull-right",
    on: {
      "click": _vm.hideMenu
    }
  }), _vm._v(" "), _c('ElInput', {
    ref: "menuSearch",
    staticClass: "translucent",
    attrs: {
      "size": "small",
      "autofocus": "",
      "placeholder": "Search Menu...",
      "prefix-icon": "el-icon-search"
    },
    model: {
      value: (_vm.searchMenu),
      callback: function($$v) {
        _vm.searchMenu = $$v
      },
      expression: "searchMenu"
    }
  })], 1), _vm._v(" "), _c('ElSubmenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.rewards, 0)),
      expression: "toShow(menuKey.rewards,0)"
    }],
    attrs: {
      "index": "1"
    }
  }, [_c('div', {
    class: {
      'menu-disabled': !_vm.hasPayTrendAccess
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-usd menu-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "lvl1"
  }, [_vm._v("Pay Trends")])]), _vm._v(" "), _c('ElMenuItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.rewards.freshgradpay, 0)),
      expression: "toShow(menuKey.rewards.freshgradpay,0)"
    }],
    attrs: {
      "disabled": !_vm.hasPayTrendAccess,
      "index": "/freshgradsal"
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_vm._v("Bachelor/Master Degree Start Rates\n            ")]), _vm._v(" "), _c('ElMenuItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.rewards.wages, 0)),
      expression: "toShow(menuKey.rewards.wages,0)"
    }],
    attrs: {
      "disabled": !_vm.hasPayTrendAccess,
      "index": "/minwage"
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_vm._v("Wages (min,living,avg)")])], 1), _vm._v(" "), _c('ElMenuItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.rewards.salaryBonusIncrease, 0)),
      expression: "toShow(menuKey.rewards.salaryBonusIncrease,0)"
    }],
    attrs: {
      "disabled": !_vm.hasForecastCalculatorAccess,
      "index": "/hrpredict"
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-calculator menu-icon"
  }), _vm._v("\n            Salary Increase Predictor\n          ")]), _vm._v(" "), _c('ElSubmenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.hrMarket, 0)),
      expression: "toShow(menuKey.hrMarket,0)"
    }],
    attrs: {
      "index": "2"
    }
  }, [_c('div', {
    class: {
      'menu-disabled': !_vm.hasHrMarketAccess
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-users menu-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "lvl1"
  }, [_vm._v("Job Markets")])]), _vm._v(" "), _c('ElMenuItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.hrMarket.jobPostings, 0)),
      expression: "toShow(menuKey.hrMarket.jobPostings,0)"
    }],
    attrs: {
      "disabled": !_vm.hasHrMarketAccess,
      "index": "/job"
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_vm._v("\n              Job Postings\n            ")]), _vm._v(" "), _c('ElMenuItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.hrMarket.talentIndicator, 0)),
      expression: "toShow(menuKey.hrMarket.talentIndicator,0)"
    }],
    attrs: {
      "disabled": !_vm.hasHrMarketAccess,
      "index": "/hr"
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_vm._v("Talent Supply Indicators\n            ")]), _vm._v(" "), _c('ElMenuItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "disabled": !_vm.hasHrMarketAccess,
      "index": "/hrMatrix"
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_vm._v("\n              HR Hiring Momentum\n            ")])], 1), _vm._v(" "), _c('ElSubmenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.relocation, 0)),
      expression: "toShow(menuKey.relocation,0)"
    }],
    attrs: {
      "index": "3"
    }
  }, [_c('div', {
    class: {
      'menu-disabled': !_vm.hasRelocationAccess
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-globe menu-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "lvl1"
  }, [_vm._v("Relocation")])]), _vm._v(" "), _c('ElMenuItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.relocation.calc, 0)),
      expression: "toShow(menuKey.relocation.calc,0)"
    }],
    attrs: {
      "disabled": !_vm.hasRelocationAccess,
      "index": "/costofliving"
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_vm._v("Relocation Calculator")]), _vm._v(" "), _c('ElMenuItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.relocation.costOfLiving, 0)),
      expression: "toShow(menuKey.relocation.costOfLiving,0)"
    }],
    attrs: {
      "disabled": !_vm.hasRelocationAccess,
      "index": "/citiescost"
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_vm._v("Cities Cost-of-Living Comparison")]), _vm._v(" "), _c('ElMenuItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.relocation.costOfLivingTrends, 0)),
      expression: "toShow(menuKey.relocation.costOfLivingTrends,0)"
    }],
    attrs: {
      "disabled": !_vm.hasRelocationAccess,
      "index": "/coltrends"
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_vm._v("Cost-of-Living Trends")])], 1), _vm._v(" "), _c('ElSubmenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.legislation, 0)),
      expression: "toShow(menuKey.legislation,0)"
    }],
    attrs: {
      "index": "4"
    }
  }, [_c('div', {
    class: {
      'menu-disabled': !_vm.hasLegislationNewsAccess
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-book menu-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "lvl1"
  }, [_vm._v("Legislations & News")])]), _vm._v(" "), _c('ElMenuItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.legislation.employmentLegislation, 0)),
      expression: "toShow(menuKey.legislation.employmentLegislation,0)"
    }],
    attrs: {
      "disabled": !_vm.hasLegislationNewsAccess,
      "index": "/legislation"
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_vm._v("\n              Employment Legislation\n            ")]), _vm._v(" "), _c('ElMenuItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.legislation.news, 0)),
      expression: "toShow(menuKey.legislation.news,0)"
    }],
    attrs: {
      "disabled": !_vm.hasLegislationNewsAccess,
      "index": "/news"
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_vm._v("\n              News Updates\n            ")])], 1), _vm._v(" "), _c('ElSubmenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.finance, 0)),
      expression: "toShow(menuKey.finance,0)"
    }],
    attrs: {
      "index": "5"
    }
  }, [_c('div', {
    class: {
      'menu-disabled': !_vm.hasFinanceProductivityAccess
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-line-chart menu-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "lvl1"
  }, [_vm._v("Financial / Productivity")])]), _vm._v(" "), _c('ElMenuItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.finance.benchmarking, 0)),
      expression: "toShow(menuKey.finance.benchmarking,0)"
    }],
    attrs: {
      "disabled": !_vm.hasFinanceProductivityAccess,
      "index": "/fm"
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_vm._v("\n              Organisation/Productivity Benchmarking\n            ")]), _vm._v(" "), _c('ElMenuItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.finance.gender, 0)),
      expression: "toShow(menuKey.finance.gender,0)"
    }],
    attrs: {
      "disabled": !_vm.hasFinanceProductivityAccess,
      "index": "/gender"
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_vm._v("\n              Gender Diversity\n            ")]), _vm._v(" "), _c('ElMenuItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "disabled": !_vm.hasFinanceProductivityAccess,
      "index": "/companyMatrix/competitors"
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_vm._v("\n              Financial Momentum\n            ")])], 1), _vm._v(" "), _c('ElMenuItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.econ, 0)),
      expression: "toShow(menuKey.econ,0)"
    }],
    attrs: {
      "disabled": !_vm.hasEconomyAccess,
      "index": "/macro"
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-bank menu-icon"
  }), _vm._v("\n            Economy\n          ")]), _vm._v(" "), (_vm.isSuperAdmin) ? _c('ElMenuItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toShow(_vm.menuKey.admin, 0)),
      expression: "toShow(menuKey.admin,0)"
    }],
    attrs: {
      "index": "/admin"
    },
    on: {
      "click": _vm.hideMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-cogs menu-icon"
  }), _vm._v("\n            Admin module\n          ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('ElMain', [_c('transition', {
    attrs: {
      "name": "el-fade-in"
    }
  }, [_c('keep-alive', [_c('router-view', {
    staticClass: "content"
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b52a228","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 609
// module chunks = 34